import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconSendMessage: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 24 20"
    sx={{
      color: COLORS.CERULEAN,
      width: 24, 
      height: 20,
      ...sx,
    }}
  >
    <path 
        d="M0.32604 3.32536L3.37563 8.34713C3.65867 8.80366 4.16085 9.0867 4.69955 9.0867C16.5327 9.07757 17.1353 9.27844 17.1444 9.99062C17.1535 10.7028 16.5601 10.9219 4.69042 10.9128C4.15172 10.9128 3.64954 11.1958 3.3665 11.6524L0.32604 16.6741C-0.760489 18.4729 1.06561 20.6185 3.01041 19.8333L22.3853 12.0359C24.2388 11.2963 24.2388 8.67583 22.3853 7.93626L3.01041 0.166208C1.05648 -0.619015 -0.760489 1.53578 0.32604 3.32536Z" 
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
